import { clsx } from "clsx";
import { Info } from "lucide-react";
import { MODE_OPTIONS } from "../../data";
import type { OnboardingMode } from "../../types";
import { StepShell } from "../step-shell";

interface ModeStepProps {
	value: OnboardingMode | null;
	onChange: (mode: OnboardingMode) => void;
	onBack: () => void;
	onContinue: () => void;
}

export function ModeStep({
	value,
	onChange,
	onBack,
	onContinue,
}: ModeStepProps) {
	return (
		<StepShell
			title="Como você organiza suas obras?"
			description="Escolha o modelo que melhor descreve o seu trabalho."
			onBack={onBack}
			onContinue={onContinue}
			continueDisabled={!value}
		>
			<div className="choice-grid">
				{MODE_OPTIONS.map((option) => {
					const OptionIcon = option.icon;
					const selected = value === option.id;
					return (
						<button
							key={option.id}
							type="button"
							onClick={() => onChange(option.id)}
							data-accent={option.accent}
							className={clsx("choice-card", selected && "is-selected")}
						>
							<span className="choice-card__icon" data-accent={option.accent}>
								<OptionIcon />
							</span>
							<span className="choice-card__title">{option.title}</span>
							<span className="choice-card__desc">{option.description}</span>
							<span className="choice-card__highlight">{option.highlight}</span>
						</button>
					);
				})}
			</div>

			<div className="onboarding-info">
				<Info className="onboarding-info__icon" />
				<p>
					Toda obra pertence a um canteiro. Na opção{" "}
					<strong className="onboarding-info__strong">obra única</strong>{" "}
					criamos o canteiro automaticamente, usando o endereço informado para a
					obra.
				</p>
			</div>
		</StepShell>
	);
}
